import { Routes, Route, Navigate } from 'react-router-dom';
import RequireAuth from '@rbac/RequireAuth';
import { RequirePermission } from '@rbac/Can';
import DefaultLayout from '@layouts/DefaultLayout';
import SiteLayout from '@layouts/SiteLayout';
import { buildRoutes } from '@/routes';
import { useModules } from '@/modules';
import Login from '@pages/Login';
import Unauthorized from '@pages/Unauthorized';
import NotFound from '@pages/NotFound';
import Home from '@pages/site/Home';
import About from '@pages/site/About';
import Services from '@pages/site/Services';
import Amc from '@pages/site/Amc';
import Training from '@pages/site/Training';
import Clients from '@pages/site/Clients';
import Gallery from '@pages/site/Gallery';
import Contact from '@pages/site/Contact';

export default function App() {
  const routes = buildRoutes(useModules());
  return (
    <Routes>
      {/* public website */}
      <Route element={<SiteLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/amc" element={<Amc />} />
        <Route path="/training" element={<Training />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/products" element={<Navigate to="/services" replace />} />
      </Route>

      {/* auth */}
      <Route path="/login" element={<Login />} />
      <Route path="/unauthorized" element={<Unauthorized />} />

      {/* protected admin area */}
      <Route element={<RequireAuth />}>
        <Route element={<DefaultLayout />}>
          {routes.map((r) => (
            <Route
              key={r.path}
              path={r.path}
              element={<RequirePermission module={r.module} action={r.action}>{r.element}</RequirePermission>}
            />
          ))}
        </Route>
      </Route>

      <Route path="/404" element={<NotFound />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
}
